export default class PromiseObserver {
  private resolves: ((value?: unknown) => void)[] = [];
  private processingCount = 0;

  public createWaitPromise(): Promise<unknown> {
    return new Promise((resolve) => {
      this.resolves.push(resolve);
    });
  }

  public notify(): void {
    const resolve = this.resolves.shift();
    if (!resolve) {
      return;
    }
    resolve();
  }

  public notifyAll(): void {
    for (const resolve of this.resolves) {
      resolve();
    }
    this.resolves = [];
  }

  // 実行中の処理がある場合は null を返し、
  // 実行中の処理がある場合は前の処理が終わるまで wait する Promise を返す
  // startProcess() を呼んだ場合は必ず endProcess() を呼ぶこと。
  public startProcess(): null | Promise<unknown> {
    ++this.processingCount;
    if (this.processingCount === 1) {
      return null;
    }
    return this.createWaitPromise();
  }

  public endProcess(): void {
    --this.processingCount;
    if (this.processingCount === 0) {
      return;
    }
    this.notify();
  }
}
